<fz-card-details>
  <!-- name -->
  <fz-card-item>
    <fz-card-item-title>Tournament</fz-card-item-title>
    <fz-card-item-description>
      <small>{{ tournamentDetails().name }}</small
      >{{ schedule().toPlayNow?.eventCode }}
    </fz-card-item-description>
  </fz-card-item>

  <!-- seats -->
  <fz-card-item label="Seats">
    <fz-card-item-title>Seats</fz-card-item-title>
    <fz-card-item-description>
      {{ schedule().totalEntryCount }}
    </fz-card-item-description>
  </fz-card-item>

  <mat-divider></mat-divider>

  <!-- entry fee -->
  <fz-card-item>
    <fz-card-item-title>Entry Fee</fz-card-item-title>
    <fz-card-item-description>
      <fz-currency [value]="schedule().entryAmount"></fz-currency>
    </fz-card-item-description>
  </fz-card-item>

  <!-- 1st prize -->
  <fz-card-item label="1st Prize">
    <fz-card-item-title>1st Prize</fz-card-item-title>
    <fz-card-item-description>
      <img src="/shared/icons/coin-bag.svg" width="24" height="24" />
      @if (firstPlacePrize()) {
        <fz-currency [value]="firstPlacePrize()!"></fz-currency>
      }
    </fz-card-item-description>
  </fz-card-item>

  <!-- zbo referral -->
  <fz-card-item>
    <fz-card-item-title info="Example info"> ZBO Referral </fz-card-item-title>
    <fz-card-item-description>
      <fz-currency [value]="zboReferral()"></fz-currency>
    </fz-card-item-description>
  </fz-card-item>

  <mat-divider></mat-divider>

  <!-- to play now -->
  <fz-card-expansion-item>
    <fz-card-item-title info="asdas dasdasd"> To Play Now </fz-card-item-title>
    <fz-card-item-description>
      @if (schedule().toPlayNow) {
        {{ schedule().toPlayNow | fzSeatsResume }}
      } @else {
        <div class="loader"></div>
      }
    </fz-card-item-description>
    <fz-card-item-body>
      <div class="cash-card__body">
        <div class="mat-body-small cash-card__body__column">
          <span>
            @if (schedule().toPlayNow) {
              {{ schedule().toPlayNow | fzSeatsResume }}
            } @else {
              <div class="loader"></div>
            }
          </span>
          <span>
            1st place:
            <b class="font-color--primary">
              @if (schedule().toPlayNow?.participants?.length) {
                {{ schedule().toPlayNow!.participants[0].player }}
              } @else {
                Be the first.
              }
            </b>
          </span>
        </div>
        <div class="mat-body-small cash-card__body__column">
          <span>
            @if (schedule().toPlayNow?.firstPlayedAt) {
              {{
                schedule().toPlayNow?.firstPlayedAt
                  | fzDateFormat: 'short'
                  | async
              }}
            } @else {
              Start this game by playing in it.
            }
          </span>
          <span>
            @if (schedule().toPlayNow?.lastPlayedAt) {
              {{
                schedule().toPlayNow?.lastPlayedAt
                  | fzDateFormat: 'short'
                  | async
              }}
            }
          </span>
        </div>
      </div>
    </fz-card-item-body>
  </fz-card-expansion-item>

  <!-- actions -->
  <fz-card-actions>
    <fz-play-button
      class="cash-card__play-button"
      [tournament]="tournamentDetails()"
      [eventSchedule]="schedule()"
    >
    </fz-play-button>
    <span class="cash-card__expanded"></span>
    <button mat-icon-button (click)="shareScheduler()">
      <mat-icon class="font-color--tertiary">share</mat-icon>
    </button>
    <a mat-icon-button [routerLink]="schedule().eventScheduleUuid">
      <mat-icon class="font-color--tertiary">visibility</mat-icon>
    </a>
  </fz-card-actions>
</fz-card-details>
